import type { FC } from 'react'

import { NameAvatar } from '@skytech/ui/NameAvatar'
import { Td } from '@skytech/ui/Table/Td'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'
import { SUB_SERVICE_ORDER_STATUS_BY_ID } from '@/modules/subscriptions/constants'

import type { Termination } from './types'

import './TerminationListItem.styles.scss'

const TerminationListItem: FC<Termination & { searchFilter: string }> = ({
  id,
  employeeNumber,
  name,
  type,
  phoneNo,
  terminationDate,
  orgNo,
  customerName,
  created,
  updated,
  searchFilter,
  status,
}) => {
  const translate = useTranslation()

  return (
    <TrLink path={`${id}`} className="termination-list-item">
      <Td>
        <NameAvatar name={name} />
      </Td>
      <Td className="mobile-view">
        <div>
          <div className="user-name">
            <Highlight pattern={searchFilter} text={name} />
          </div>

          {phoneNo && (
            <div className="phone-no">
              <Highlight pattern={searchFilter} text={String(phoneNo)} />
            </div>
          )}
        </div>

        <div>
          <div className="status">
            <Highlight
              pattern={searchFilter}
              text={translate(`sub_service_order_status/${SUB_SERVICE_ORDER_STATUS_BY_ID[status]}`)}
            />
          </div>

          <div className="activation-date">
            <LocalDate date={terminationDate} />
          </div>
        </div>
      </Td>
      <Td>
        <div className="user-name">
          <Highlight pattern={searchFilter} text={name} />
        </div>

        {employeeNumber && (
          <div className="employee-no">
            <Highlight pattern={searchFilter} text={String(employeeNumber)} />
          </div>
        )}
      </Td>

      <Td>{phoneNo && <Highlight pattern={searchFilter} text={String(phoneNo)} />}</Td>
      <Td>
        <div className="company-name">
          <Highlight pattern={searchFilter} text={customerName} />
        </div>

        <div className="company-number">
          <Highlight pattern={searchFilter} text={String(orgNo)} />
        </div>
      </Td>

      <Td>
        <div className="status">
          <Highlight
            pattern={searchFilter}
            text={translate(`sub_service_order_status/${SUB_SERVICE_ORDER_STATUS_BY_ID[status]}`)}
          />
        </div>

        <div className="type">
          <Highlight pattern={searchFilter} text={translate(`termination_type/${type}`)} />
        </div>
      </Td>

      <Td>
        <LocalDate date={terminationDate} />
      </Td>

      <Td>
        <LocalDate date={created} />
      </Td>
      <Td>
        <LocalDate date={updated} />
      </Td>
    </TrLink>
  )
}

export default TerminationListItem
